<template>
  <section class="platform-panel" aria-label="플랫폼별 정산">
    <header class="panel-header">
      <span><i class="el-icon-pie-chart"></i>{{ $t('플랫폼별 정산') }}</span>
    </header>
    <div v-if="hasChart" ref="chart" class="chart" role="img" aria-label="플랫폼별 정산 도넛 차트"></div>
    <el-table
      :data="platforms"
      size="small"
      border
      :empty-text="$t('데이타 없음')"
      @row-click="$emit('select-platform', $event.platform)">
      <el-table-column :label="$t('플랫폼')" prop="platform" min-width="130">
        <template slot-scope="scope">{{ platformDisplayName(scope.row.platform) }}</template>
      </el-table-column>
      <el-table-column :label="$t('정산 예상')" prop="expected_settlement" min-width="120" align="right">
        <template slot-scope="scope">{{ formatCurrency(scope.row.expected_settlement) }}</template>
      </el-table-column>
      <el-table-column :label="$t('건수')" prop="transaction_count" width="80" align="right"></el-table-column>
    </el-table>
  </section>
</template>

<script>
import { platformDisplayName } from '@/utils/deliveryPlatform'

export default {
  props: {
    platforms: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chart: null,
      hasChart: false,
    }
  },
  watch: {
    platforms: {
      deep: true,
      handler() {
        this.$nextTick(this.renderChart)
      },
    },
  },
  mounted() {
    this.hasChart = Boolean(window.echarts)
    this.$nextTick(this.renderChart)
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
    if (this.chart) this.chart.dispose()
  },
  methods: {
    platformDisplayName,
    formatCurrency(value) {
      return `${Number(value || 0).toLocaleString()}원`
    },
    renderChart() {
      if (!window.echarts || !this.$refs.chart) return
      if (this.chart) this.chart.dispose()
      this.chart = window.echarts.init(this.$refs.chart)
      const colors = ['#F27438', '#3B7DDD', '#52C41A', '#FAAD14', '#8C8CA1', '#FF4D4F']
      this.chart.setOption({
        color: colors,
        tooltip: {
          trigger: 'item',
          formatter: (params) => `${params.name}<br/>${this.formatCurrency(params.value)} (${params.percent}%)`,
        },
        legend: {
          type: 'scroll',
          bottom: 0,
          textStyle: { fontSize: 11 },
        },
        series: [
          {
            type: 'pie',
            radius: ['48%', '70%'],
            center: ['50%', '42%'],
            label: { show: false },
            itemStyle: { borderColor: '#fff', borderWidth: 2, borderRadius: 4 },
            data: this.platforms.map((item) => ({
              name: this.platformDisplayName(item.platform),
              value: Number(item.expected_settlement || 0),
            })),
          },
        ],
      })
      this.chart.off('click')
      this.chart.on('click', (params) => {
        const item = this.platforms[params.dataIndex]
        if (item && item.platform) {
          this.$emit('drilldown-platform', item.platform)
        }
      })
    },
    resize() {
      if (this.chart) this.chart.resize()
    },
  },
}
</script>

<style scoped>
.platform-panel {
  min-width: 0;
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: 16px;
  overflow: hidden;
  box-shadow: var(--shadow-card);
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  color: var(--color-text-primary);
  font-size: 15px;
  font-weight: 600;
}

.panel-header span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.panel-header i {
  color: var(--color-primary);
}

.chart {
  width: 100%;
  max-width: 100%;
  height: 260px;
}

@media (max-width: 768px) {
  .chart {
    height: 220px;
  }
}
</style>
